// extracted by mini-css-extract-plugin
export default {"warpper":"Layout_warpper__tFb5w"};